import { jsx as c } from "react/jsx-runtime";
import { MaterialIconSize as s } from "./MaterialIconSize.type.mjs";
const n = (i) => {
  const { icon: t, style: o, size: m, className: e, ariaLabel: l, testId: r } = i, a = [];
  switch (m) {
    case s.SIZE_14:
      a.push("adel-material-symbols-14");
      break;
    case s.SIZE_16:
      a.push("adel-material-symbols-16");
      break;
    case s.SIZE_18:
      a.push("adel-material-symbols-18");
      break;
    case s.SIZE_20:
      a.push("adel-material-symbols-20");
      break;
    case s.SIZE_24:
      a.push("adel-material-symbols-24");
      break;
    case s.SIZE_36:
      a.push("adel-material-symbols-36");
      break;
    default:
      a.push("adel-material-symbols");
      break;
  }
  return e && a.push(e), /* @__PURE__ */ c(
    "span",
    {
      className: a.join(" "),
      style: o,
      "data-testid": r ? `${r}-icon` : null,
      "aria-label": l || void 0,
      "aria-hidden": l ? void 0 : "true",
      children: t
    }
  );
};
export {
  n as MaterialIcon
};
//# sourceMappingURL=MaterialIcon.mjs.map
